import { render, staticRenderFns } from "./BootswatchThemeSelect.vue?vue&type=template&id=15fe2ce6&scoped=true&"
import script from "./BootswatchThemeSelect.vue?vue&type=script&lang=ts&"
export * from "./BootswatchThemeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fe2ce6",
  null
  
)

export default component.exports